// extracted by mini-css-extract-plugin
module.exports = {"Revista":"Revista_Revista__2qfN2","TituloPrincipal":"Revista_TituloPrincipal__2nxTJ","Articulos":"Revista_Articulos__1eqOU"};